module.exports = __webpack_public_path__ + "static/media/bg-chat.1e97e84c.png";